import request from "@/utils/oms-request";
import lms_request from "@/utils/request";
import download from "@/utils/oms-download";
// 询价单列表
export const getInquirySheet = (params: any) =>
    request({
        url: "/inquiry-sheet",
        method: "get",
        params,
    });
// 匹配报价
export const matchInquiry = (taskId: any) =>
    request({
        url: `/inquiry-sheet/match-inquiry/${taskId}`,
        method: "put",
    });
// 导出详情
export const exportInquirySheetDetail = (id: any, accountTypeByOperation: string) =>
    download({
        responseType: "blob",
        url: `/inquiry-sheet/${id}/detail/excel`,
        method: "get",
        params: {
            accountTypeByOperation: accountTypeByOperation
        }
    });
// 下载源文件
export const exportSourceFile = (id: any) =>
    download({
        responseType: "blob",
        url: `/task/${id}/oss-file`,
        method: "get",
    });
// 导出询价单历史价格
export const exportInquirySheetHistoryPrice = (params: any) =>
    download({
        responseType: "blob",
        url: "/inquiry-sheet/customer-quotation-list",
        method: "get",
        params,
    });
// 删除询价单
export const deleteInquirySheet = (id: any) =>
    request({
        url: `/inquiry-sheet/${id}`,
        method: "delete",
    });
// 询价单导出包装资料
export const exportInquirySheetPackageInfo = (params: any) =>
    download({
        responseType: "blob",
        url: `/inquiry-sheet/download/package-info`,
        method: "get",
        params,
    });
// 销售员列表
export const getSalesmanList = () =>
    lms_request({
        url: "/users/all-seller",
        method: "get",
    });
// 销售助理列表
export const getSaleAssistantList = () =>
    lms_request({
        url: "/users/all-seller-assistant",
        method: "get",
    });

// 供应商列表
export const getSuppliersList = (params: any) =>
    lms_request({
        url: "/suppliers/abbreviation",
        method: "get",
        params,
    });
export const getNumberTypes = () =>
    request({
        url: "/number_types",
        method: "get",
    });
// 新建询价单
export const addInquirySheet = (data: any) =>
    request({
        url: "/inquiry-sheet",
        method: "post",
        data,
    });
// 询价单详情
export const getInquirySheetDetail = (params) =>
    request({
        url: "/inquiry-sheet/search/info",
        method: "get",
        params,
    });
// 询价单详情-删除
export const deleteInquirySheetDetail = (id: any) =>
    request({
        url: `/inquiry-sheet/detail/${id}`,
        method: "delete",
    });
// 询价单详情-查看其他价格
export const getInquirySheetOtherPrice = (data) =>
    request({
        url: `/inquiry-sheet/search/price-info`,
        method: "post",
        data,
    });
// 询价单详情-查看属性
export const getInquirySheetDetailDesc = (data) =>
    request({
        url: `/inquiry-sheet/search/desc-info`,
        method: "post",
        data,
    });
// 询价单详情-产品号码
export const getInquirySheetDetailModel = (data) =>
    request({
        url: `/inquiry-sheet/search/model`,
        method: "post",
        data,
    });
//  询价单详情-保存报价
export const saveInquirySheetDetail = (id: any) =>
    request({
        url: `/inquiry-sheet/${id}/detail/quotes`,
        method: "put",
    });
//  询价单详情-添加备注
export const addInquirySheetRemark = (id: any, data: any) =>
    request({
        url: `/inquiry-sheet/detail/${id}/remark`,
        method: "put",
        data,
    });
//  询价单详情-下单状态
export const getInquirySheetOrderStatus = () =>
    request({
        url: "/inquiry-sheet/order-status",
        method: "get",
    });
//  询价单详情-查看历史报价
export const getInquirySheetHistory = (id: any, params: any) =>
    request({
        url: `/inquiry-sheet/detail/${id}/history`,
        method: "get",
        params,
    });

// 新询价-直接生成
export const createInquirySheetDirect = (data: any) =>
    request({
        url: `/inquiry-sheet/create-new`,
        method: "post",
        data,
    });
// 新建询价单
export const createInquirySheet = (data: any) =>
    request({
        url: "/inquiry-sheet",
        method: "post",
        data,
    });
// 报单价审核-复制型号
export const copyInquirySheet = (id: any) =>
    request({
        url: `/inquiry-sheet/${id}/copy`,
        method: "post",
    });
// PI草稿-上传维护
export const uploadInquirySheet = (data: FormData) =>
    request({
        url: `/inquiry-sheet/upload-proforma-invoice`,
        method: "post",
        data,
    });
// 生成PI草稿-直接生成
export const createInquirySheetPI = (data: any) =>
    request({
        url: `/inquiry-sheet/draft`,
        method: "post",
        data,
    });
// 移除PI草稿中的产品
export const removeInquirySheetPIProduct = (params: any) =>
    request({
        url: `/inquiry-sheet/draft`,
        method: "delete",
        params,
    });
// 移除报价单审核中的产品
export const removeRecordsProduct = (params: any) =>
    request({
        url: `/inquiry-approval-records/remove-association?${params}`,
        method: "put",
    });
// PI草稿-批量修改折扣
export const updateDraftDiscount = (data: any) =>
    request({
        url: `/inquiry-sheet/draft/discount`,
        method: "post",
        data,
    });
// 报价单审核-修改折扣
export const updateRecordsDiscount = (data: any) =>
    request({
        url: `/inquiry-approval-records/discount`,
        method: "put",
        data,
    });
// PI草稿-修改数量
export const updateDraftQuantity = (id: any, data: any) =>
    request({
        url: `/inquiry-sheet/draft/${id}/product-quantity?productQuantity=${data}`,
        method: "put",
    });
// PI草稿-修改品牌
export const updateDetailBrandName = (id: any, data: any) =>
    request({
        url: `/inquiry-sheet/draft/${id}/brand-name?brandId=${data}`,
        method: "put",
    });
// 报价单审核-修改数量
export const updateInquirySheetQuantity = (params: any) =>
    request({
        url: `inquiry-approval-records/inquiry-sheet-info/product-quantity`,
        method: "put",
        params,
    });
// 报价单审核-修改品牌
export const updateInquirySheetBrandName = (params: any) =>
    request({
        url: `inquiry-approval-records/inquiry-sheet-info/brand-name`,
        method: "put",
        params,
    });
// PI草稿-维护折算利润率和采购折扣
export const updateDraftDiscountAndProfit = (data: any) =>
    request({
        url: `/inquiry-sheet/conversion-profit-margin`,
        method: "put",
        data,
    });
// 报价单审核-维护折算利润率
export const updateRecordsProfit = (data: any) =>
    request({
        url: `/inquiry-approval-records/conversion-profit-margin`,
        method: "put",
        data,
    });
// PI草稿-单价修改
export const updateDraftUnitPrice = (data: any) =>
    request({
        url: `/inquiry-sheet/draft/unit-price`,
        method: "put",
        data,
    });
// 报价单审核-单价修改
export const updateRecordsUnitPrice = (id: any, params: any) =>
    request({
        url: `/inquiry-approval-records/${id}/unit-price`,
        method: "put",
        params,
    });
// 报价单审核-上传维护
export const uploadInquiryApprovalRecord = (data: FormData) =>
    request({
        headers: {"Content-Type": "multipart/form-data"},
        url: "/inquiry-approval-records/upload-inquiry-approval-record",
        method: "post",
        data,
    });
// PI草稿-保存报价
export const saveInquirySheet = (id: any) =>
    request({
        url: `/inquiry-sheet/${id}/draft/quote`,
        method: "put",
    });
// PI草稿-上传维护
export const uploadPiDraft = (data: FormData) =>
    request({
        headers: {"Content-Type": "multipart/form-data"},
        url: "/inquiry-sheet/upload-pi-draft",
        method: "post",
        data: data,
    });
// PI草稿-下载
export const downloadDraft = (id: any, accountTypeByOperation: string, draftIds: string[] = []) =>
    download({
        responseType: "blob",
        url: `/inquiry-sheet/download-draft`,
        method: "post",
        data: {
            id,
            accountType: accountTypeByOperation,
            draftIds
        }
    });
export const disabledProductCategory = (id: any) =>
    request({
        url: `/product-categories/${id}/update-disabled`,
        method: "put",
    });
// PI草稿-编辑查询
export const getEditSearch = (params: any) =>
    request({
        url: `/inquiry-approval-records/edit-search`,
        method: "get",
        params,
    });
// 询价状态
export const getInquiryStatus = () =>
    request({
        url: "/inquiry-sheet/all-state",
        method: "get",
    });
// PI草稿列表
export const getDraftList = (params: any) =>
    request({
        url: "/inquiry-sheet/search-pi",
        method: "get",
        params,
    });

// PI草稿-结算筛选状态
export const getDraftStatus = () =>
    request({
        url: "/inquiry-sheet/draft/status",
        method: "get",
    });
// PI草稿-单价类型
export const getDraftPriceType = () =>
    request({
        url: "/inquiry-sheet/unit-price-type",
        method: "get",
    });
export const putDraftPriceType = (params: any) =>
    request({
        url: "/inquiry-sheet/draft/unit-price-type",
        method: "put",
        params,
    });
// PI草稿-提交审批
export const submitDraft = (data: any) =>
    request({
        url: `/inquiry-sheet/draft/submit-review`,
        method: "put",
        data,
    });
// 查看折算汇率 /inquiry-sheet/conversion_exchange_rate
export const getConversionExchangeRate = (params: any) =>
    request({
        url: `/inquiry-sheet/conversion_exchange_rate`,
        method: "get",
        params,
    });
// PI草稿-更换供应商
export const changeDraftSupplier = (id: any, params: any) =>
    request({
        url: `/inquiry-sheet/draft/${id}/supplier`,
        method: "put",
        params,
    });
//
export const getPIcode = (id: any) =>
    request({
        url: `/inquiry-approval-records/${id}/pi-code`,
        method: "get",
    });
// 报价单审核-更换供应商
export const changeQuotationSupplier = (params: any) =>
    request({
        url: `/inquiry-approval-records/inquiry-sheet-info/supplier`,
        method: "put",
        params,
    });
// 报价单审核-列表
export const getQuotationList = (params: any) =>
    request({
        url: "/inquiry-approval-records",
        method: "get",
        params,
    });

// 报价单审核-详情
export const getQuotationDetail = (params: any) =>
    request({
        url: "/inquiry-approval-records/details",
        method: "get",
        params,
    });

// 报价单审核-删除询报价单号
export const deleteQuotation = (id: any) => {
    request({
        url: `/inquiry-approval-records/audit/${id}`,
        method: "delete",
    });
};
// 报价单审核-移除
export const removeQuotation = (id: any) =>
    request({
        url: `/inquiry-approval-records/audit/${id}`,
        method: "delete",
    });
// 报价单审核-状态
export const getRecordsStatus = (id: any) =>
    request({
        url: `/inquiry-approval-records/${id}/status`,
        method: "get",
    });
// 报价单审核-状态
export const getQuotationStatus = () =>
    request({
        url: "/inquiry-approval-records/state",
        method: "get",
    });
// 报价单审核-生成PI
export const generatePI = (id: any, params) =>
    request({
        url: `/inquiry-approval-records/${id}/generate-proforma-invoices`,
        method: "put",
        params
    });

// 预览新生成的 PI 号码
export const previewPiCode = (id: string) =>
    request({
        url: `/inquiry-approval-records/${id}/preview-pi-code`,
        method: "get",
    });

// 报价单审核-验审-挂起
export const auditHold = (params: any) =>
    request({
        url: `/inquiry-approval-records/audit-hold`,
        method: "put",
        params,
    });
// 报价单审核-验审-取消挂起
export const auditCancelHold = (params: any) =>
    request({
        url: `/inquiry-approval-records/audit-cancel-hold`,
        method: "put",
        params,
    });
// 报价单审核-审核通过
export const auditPass = (id: any) =>
    request({
        url: `/inquiry-sheet/approval-record/${id}/examination-passed`,
        method: "put",
    });
// 报价单审核-取消审核
export const cancelPass = (id: any) =>
    request({
        url: `/inquiry-approval-records/${id}`,
        method: "put",
    });
// 报价单审核-复制型号
export const copyQuotation = (id: any) =>
    request({
        url: `/inquiry-sheet/${id}/copy`,
        method: "post",
    });
// 报价单审核-下载
export const downloadQuotation = (id: any, accountType: string, detailInfoIds: string[] = []) =>
    download({
        responseType: "blob",
        url: `/inquiry-approval-records/download`,
        method: "post",
        data: {
            id,
            accountType,
            detailInfoIds
        }
    });

// /payment_voucher/distribute-deposit
export const getDistributeDeposit = (params: any) =>
    request({
        url: `/payment_voucher/distribute-deposit`,
        method: "get",
        params,
    });

export const getRemainingDeposit = (params: any) =>
    request({
        url: `/payment_voucher/remaining-deposit`,
        method: "get",
        params,
    });
// /inquiry-approval-records/audit-hold/remark
// 挂起原因
export const getAuditHoldRemark = (params: any) =>
    request({
        url: `/inquiry-approval-records/audit-hold/remark`,
        method: "get",
        params,
    });

// /inquiry-sheet/{id}/
// 判断是否存在未匹配

export const getInquirySheetPiPei = (id: any) =>
    request({
        url: `/inquiry-sheet/${id}`,
        method: "get",
    });

// 询价单的匹配/维护状态
// /inquiry-sheet/{id}/state
export const getInquirySheetState = (id: any) =>
    request({
        url: `/inquiry-sheet/${id}/state`,
        method: "get",
    });

// 下载报价单PI
// /inquiry-approval-records/{id}/download-pi-template
export const downloadPiTemplate = (id: any, params: any) =>
    download({
        responseType: "blob",
        url: `/inquiry-approval-records/${id}/download-pi-template`,
        method: "get",
        params,
    });

// 勾选下载报价单
// /inquiry-sheet/detail/excel
export const downloadCheckQuotation = (data) =>
    download({
        responseType: "blob",
        url: `/inquiry-sheet/detail/excel`,
        method: "post",
        data,
    });

export const getExtend = (id: any) =>
    request({
        url: `/inquiry-sheet/detail/${id}/extend`,
        method: "get"
    });
// 导出询价单历史报价
// /inquiry-sheet/{id}/history-price
export const exportAskingHistory = (id: any) =>
    download({
        responseType: "blob",
        url: `/inquiry-sheet/${id}/history-price`,
        method: "get"
    });

export const addNumberType = (id: string, data: any) =>
    request({
        url: `/inquiry-sheet/detail/${id}/add-model`,
        method: "put",
        data,
    });
// /product_numbers/{id}/extend
export const putExtendInquiry = (id: any, data) =>
    request({
        url: `/inquiry-sheet/detail/${id}/extend`,
        method: "put",
        data
    });

// /customer-inventory/{id}/customs-packing/search-inventory
export const getSearchInventory = (id: any) =>
    request({
        url: `/customer-inventory/${id}/customs-packing/search-inventory`,
        method: "get"
    });

// /inquiry-sheet/{id}/product-number/extends
// 询价单详情下载备注
export const getProductNumberExtends = (id: any) =>
    download({
        responseType: "blob",
        url: `/inquiry-sheet/${id}/product-number/extends`,
        method: "get",
    });

// /customer-inventory/reset-inventory/{id}
export const putResetInventory = (ids: any) =>
    request({
        url: `/customer-inventory/reset-inventory`,
        method: "put",
        data: ids
    });

// /customer-in-inventory/update-remark/{id}
export const putGuestsInStockRemark = (id: any, data) =>
    request({
        url: `/customer-in-inventory/update-remark/${id}`,
        method: "put",
        data
    });

// /inquiry-sheet/{id}/product-number-extends/upload-oss
export const constcheckWhetherItCanBeSaved = (id: any) =>
    request({
        url: `/inquiry-sheet/${id}/product-number-extends/upload-oss`,
        method: "post"
    });

  export const updateCurrency = (id: string, params: any) =>
      request({
          url: `/inquiry-sheet/${id}/currency`,
          method: "put",
          params,
      });

  // 追加PI
  export const appendPI = (params) =>
      request({
          url: `/inquiry-approval-records/append-proforma-invoice`,
          method: "put",
          params,
      });
